
(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-p2c-home-carousel]').forEach((track) => {
      if (track.dataset.p2cCarouselReady === 'true') return;

      const section = track.closest('section');
      const cards = Array.from(track.querySelectorAll('[data-p2c-home-card]'));
      const dots = Array.from(section?.querySelectorAll('[data-p2c-home-dot]') || []);

      if (!section || cards.length < 2 || dots.length < 2) return;
      track.dataset.p2cCarouselReady = 'true';

      const update = () => {
        const left = track.getBoundingClientRect().left;
        let active = 0;
        let best = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          if (distance < best) {
            best = distance;
            active = index;
          }
        });

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
        });
      };

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          cards[index]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });
      });

      update();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
